<template>
  <div>
    <div class="info-card" ref="cards">
      <div class="info-section" v-if="d.organisation && d.organisation.title">
        <div class="value supertitle">{{ d.organisation.title }}</div>
      </div>

      <div v-if="d && d.address" class="info-section">
        <div class="title">Адреса</div>
        <div class="value">{{ d.address }}</div>
      </div>

      <div class="map-action">
        <GoogleMapButton :d="d"/>
      </div>

      <div class="details-grid">
        <div
          class="info-field"
          v-for="field in infoFields"
          :key="field.key"
        >
          <div class="title">{{ field.title }}</div>
          <div :class="['value', field.className]">
            <a v-if="field.href" :href="field.href">{{ field.value }}</a>
            <span v-else>{{ field.value }}</span>
          </div>
        </div>
      </div>

      <div class="schedule-grid">
        <div class="schedule-field">
          <div class="title">Графік роботи лікаря</div>
          <div class="value">
            <ScheduleView :schedule="d.schedule_of_doctor"/>
          </div>
        </div>

        <div class="schedule-field">
          <div class="title">Графік роботи кабінету видачі ЗПТ</div>
          <div class="value">
            <ScheduleView :schedule="d.schedule_of_zpt"/>
          </div>
        </div>
      </div>

      <!-- <div class="info-section">
        <div class="title">Статус роботи</div>
        <div class="value">{{ d.status || ""  }}</div>
      </div> -->

      <!--<div class="info-section">
        <div class="title">Лікар</div>
        <div class="value">
          {{ doc.position || "" }}
          {{ doc.last_name || "" }}
          {{ doc.name || "" }}
          {{ doc.surname || "" }}
        </div>
      </div>-->

      <!--<div class="info-section">
        <div class="title">Контакти лікаря</div>
        <div class="value">
          {{ doc.phone_number || "" }}
          {{ doc.email || "" }}
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import GoogleMapButton from './GoogleMapButton.vue';
import ScheduleView from "@/components/ScheduleView.vue";

export default {
  components: {ScheduleView, GoogleMapButton},
  props: ["d"],

  computed: {
    //   address() {
    //     return [
    //         this.d.region, this.d.settlement_name, this.d.street, this.d.street_number
    //     ].join(", ")
    //   },

    doc() {
      let doc = this.d.hospitality_doctor[0];
      if (!doc) return {};
      return doc;
    },
    displayEmail() {
      return this.d?.hosp_email || this.d?.email || '';
    },
    infoFields() {
      return [
        {
          key: "doctor-cabinet",
          title: "Номер кабінету лікаря",
          value: this.displayValue(this.doc.cabinet_number),
        },
        {
          key: "zpt-cabinet",
          title: "Номер кабінету видачі ЗПТ",
          value: this.displayValue(this.d.cabinet_number),
        },
        {
          key: "phone",
          title: "Телефон для довідок з питань ЗПТ",
          value: this.displayValue(this.d.info_phone_number),
        },
        {
          key: "email",
          title: "E-mail закладу",
          value: this.displayValue(this.displayEmail),
          href: this.displayEmail ? `mailto:${this.displayEmail}` : "",
        },
        {
          key: "buprenorphin",
          title: "Наявність Бупренорфіну",
          value: this.courses2human(this.d.buprenorphin_available),
          className: this.availabilityClass(this.d.buprenorphin_available),
        },
        {
          key: "methadon",
          title: "Наявність Метадону",
          value: this.courses2human(this.d.methadon_available),
          className: this.availabilityClass(this.d.methadon_available),
        },
      ];
    }
  },

  methods: {
    displayValue(val) {
      return val || "–";
    },
    courses2human(val) {
      if (!val || val <= 0) return 'немає вільних курсів';
//      return `${+val} вільних курсів`;
      return `в наявності`;
    },
    availabilityClass(val) {
      return val && val > 0 ? "text-green" : "text-orange";
    }
  }
}
</script>

<style lang="scss" scoped>
.info-card {
  color: var(--col-mainblue);
  padding: 0.5rem;
  display: grid;
  gap: 1rem;

  h3 {
    margin-bottom: 1em;
  }

  p {
    margin-bottom: 1em;
  }

  hr {
    border: 1px solid white;
  }

  .title {
    font-style: normal;
  }

  .value {
    font-weight: 600;
  }

  .text-orange {
    color: var(--col-text-orange);
  }

  .text-green {
    color: var(--col-text-green);
  }

  .supertitle {
    font-size: 1.3rem;
  }
}

.info-section {
  min-width: 0;
}

.map-action {
  min-height: 2.2rem;
}

.details-grid,
.schedule-grid {
  display: grid;
  gap: 1rem 1.4rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.schedule-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
}

.info-field,
.schedule-field {
  min-width: 0;
}

.info-field a {
  color: var(--col-mainblue);
  overflow-wrap: anywhere;
}

@media (max-width: 900px) {
  .details-grid,
  .schedule-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .details-grid,
  .schedule-grid {
    grid-template-columns: 1fr;
  }
}

</style>
